import http from "./http";
import {UserLoginModel} from "../models/user.models";

const BASE_URL = process.env.REACT_APP_AUTH_API_ENDPOINT;


const login = (data: UserLoginModel) => {
  return http.post("/login", data,{baseURL: BASE_URL});
};

const AuthService = {
  login
}

export default AuthService;